<template>
  <div>
    <div
      style="border-radius: 8px !important"
      class="kanban-main-cards d-flex"
      :class="
        candidateDocsUploaded && !checkIfCandPushed && 'docs-uploaded-border'
      "
    >
      <div class="w-15 position-relative">
        <div
          class="mr-2"
          :class="
            candidate.customFields &&
            candidate.customFields.imageMedia &&
            candidate.customFields.imageMedia != null
              ? 'common-sm-profile-transparet-icon'
              : 'common-sm-profile-icon'
          "
        >
          <b-avatar
            v-if="
              candidate.customFields &&
              candidate.customFields.imageMedia &&
              candidate.customFields.imageMedia != null
            "
            :src="candidate.customFields.imageMedia"
          ></b-avatar>
          <b-avatar v-else :text="candidate.name[0].toUpperCase()"></b-avatar>
        </div>
        <div
          v-if="candidateDocsUploaded && !checkIfCandPushed"
          class="
            pushed-cand-dp
            d-flex
            align-items-center
            justify-content-center
          "
          v-b-tooltip.hover.bottom="
            candidate.documentStatus == 3 ||
            candidate.documentStatus == 0 ||
            candidate.documentStatus == 6
              ? 'Candidate is yet to submit the documents'
              : 'Document approval is pending'
          "
        >
          <img src="../../assets/img/newkanban/docs-uploaded.svg" alt="" />
        </div>
      </div>
      <div class="w-85">
        <div class="d-flex">
          <div class="w-75 text-truncate kanban-maincards-mainhead">
            {{ candidate.name }}
          </div>
          <div
            class="
              w-25
              d-flex
              align-items-center
              justify-content-end
              position-relative
            "
          >
            <img
              v-if="
                selectedCandidate.candidateID == candidate.candidateID &&
                viewCandidateModal
              "
              src="../../assets/img/newcreatejob/hideicon.svg"
              alt=""
              class="pointer"
            />
            <img
              v-else
              :class="isSchedule && 'disabled-kanban-img'"
              @click="!isSchedule && $emit('view-candidate')"
              src="../../assets/img/newkanban/view.svg"
              alt=""
              class="pointer"
            />
            <img
              tabindex="0"
              @click.stop="
                isSchedule || jobOnHold
                  ? ''
                  : selectedID != candidate.candidateID
                  ? selectCand()
                  : closeCand()
              "
              :class="(isSchedule || jobOnHold) && 'disabled-kanban-img'"
              class="ml-2 kanban-image-hover pointer"
              src="../../assets/img/newkanban/more.svg"
              alt=""
            />
            <div
              :ref="'closecard' + candidate.candidateID"
              v-if="selectedID == candidate.candidateID"
              class="kanban-more-option-card"
            >
              <div
                v-if="
                  (candidate.documentStatus == 5 ||
                    candidate.documentStatus == null) &&
                  checkCandToPush &&
                  showOptions
                "
                class="kanban-more-option-card-input"
                @click="$emit('setshareval', reShare), $emit('sharetoclient')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/pushcandidate.svg"
                  class="mr-1"
                  alt=""
                />
                {{
                  candidate.customerID[particularJob.customerID][
                    particularJob.jobID
                  ].documentRejectedByRecruiter && candidate.documentStatus == 5
                    ? "Re-Share to Client"
                    : "Share to Client"
                }}
              </div>
              <div
                v-if="
                  (candidate.documentStatus == 3 ||
                    candidate.documentStatus == 0 ||
                    candidate.documentStatus == 6) &&
                  !checkIfCandPushed
                "
                class="kanban-more-option-card-input"
                @click="closeCand(), $emit('request-docs')"
              >
                <img
                  src="../../assets/img/newkanban/reviewdocuments.svg"
                  class="mr-2"
                  alt=""
                />
                Request Documents
              </div>
              <div
                v-if="
                  (candidate.documentStatus == 2 ||
                    candidate.documentStatus == 4) &&
                  !checkIfCandPushed
                "
                class="kanban-more-option-card-input"
                @click="$emit('goto-viewodcs', candidate.candidateID)"
              >
                <img
                  src="../../assets/img/newkanban/reviewdocuments.svg"
                  class="mr-2"
                  alt=""
                />
                Review Documents
              </div>
              <div
                @click="addAttach = !addAttach"
                :style="
                  addAttach && 'background: rgb(200, 217, 229) !important;'
                "
                class="kanban-more-option-card-input relativeclass"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <img
                      src="../../assets/new-icons/attachment-icon.svg"
                      class="mr-1"
                      alt=""
                    />
                    Add Attachment
                  </div>
                  <img
                    v-if="addAttach"
                    src="../../assets/new-kanban-icons/up-arrow.svg"
                    class="mr-1"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/new-kanban-icons/down-arrow.svg"
                    class="mr-1"
                    alt=""
                  />
                </div>
                <div
                  v-if="addAttach"
                  class="status-dropdown d-flex w-100 px-3 py-2"
                >
                  <div>
                    <img
                      src="../../assets/new-kanban-icons/straight-big-line.svg"
                      alt=""
                    />
                  </div>

                  <!-- status-dropdown-inner-container-selected -- bind this -->
                  <div class="status-dropdown-inner-container ml-2">
                    <div
                      class="status-dropdown-inner-container-unselected"
                      @click="
                        (addAttach = false),
                          $emit('show-add-attachment', candidate)
                      "
                    >
                      Media
                    </div>
                    <div
                      @click="
                        (addAttach = false), $emit('show-add-note', candidate)
                      "
                      class="status-dropdown-inner-container-unselected"
                    >
                      Note
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center w-100">
          <img src="../../assets/img/newkanban/mail.svg" alt="" />
          <span class="w-70 text-truncate kanban-maincards-mailncall ml-1">
            {{ candidate.email }}
          </span>
        </div>
        <div class="mt-1 w-100">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="kanban-maincards-mailncall">
              <img src="../../assets/img/newkanban/phone.svg" alt="" />
              {{ candidate.phoneNumber }}
            </div>
            <div
              :style="'color:#FFC145'"
              class="kanban-maincards-nottriggered"
              v-if="
                candidate.documentStatus != null &&
                candidate.documentStatus == 3 &&
                !checkIfCandPushed
              "
            >
              Pending Docs
            </div>
            <div
              v-else
              class="kanban-maincards-nottriggered"
              :style="
                checkIfCandPushed
                  ? 'color: #20639b'
                  : candidate.documentStatus == 0 ||
                    candidate.documentStatus == 6
                  ? 'color: #eb0002'
                  : (candidate.customerID[particularJob.customerID][
                      particularJob.jobID
                    ].documentRejectedByRecruiter &&
                      candidate.documentStatus == 2) ||
                    candidate.documentStatus == 4
                  ? 'color:#038E00'
                  : 'color: #20639b'
              "
            >
              {{
                checkIfCandPushed
                  ? "Shared"
                  : candidate.documentStatus == 0
                  ? "Rejected by Recruiter"
                  : candidate.documentStatus == 6
                  ? "Docs Rejected"
                  : candidate.documentStatus == 2 ||
                    candidate.documentStatus == 4
                  ? "Review Docs"
                  : "Not Shared"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    candidate: Object,
    isSchedule: Boolean,
    selectedID: String,
    selectedCandidate: Object,
    viewCandidateModal: Boolean,
    candidatesToPush: Number,
    totalPushed: Number,
    particularJob: Object,
    jobOnHold: Boolean,
  },
  data() {
    return {
      reShare: false,
      addAttach: false,
    };
  },
  created() {
    if (
      this.candidate.customerID[this.particularJob.customerID][
        this.particularJob.jobID
      ].documentRejectedByRecruiter &&
      this.candidate.documentStatus == 5 &&
      this.checkCandToPush
    ) {
      this.reShare = true;
    } else if (this.candidate.documentStatus == 5 && this.checkCandToPush) {
      this.reShare = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.closeOnOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeOnOutside);
  },
  computed: {
    candidateDocsUploaded() {
      return (
        this.candidate.documentStatus != null &&
        this.candidate.documentStatus != 5
      );
    },
    showOptions() {
      if (this.candidate.documentStatus == null) {
        return this.checkCandToPush && !this.candidate.pushed;
      } else {
        return (
          !this.checkShareToClient ||
          (this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].documentRejectedByRecruiter &&
            (this.candidate.documentStatus == 0 ||
              this.candidate.documentStatus == 2 ||
              this.candidate.documentStatus == 4 ||
              this.candidate.documentStatus == 5 ||
              this.candidate.documentStatus == 6))
        );
      }
    },
    checkCandToPush() {
      if (this.candidatesToPush == null) {
        return true;
      } else {
        return this.totalPushed < this.candidatesToPush;
      }
    },
    checkIfCandPushed() {
      if (this.candidate.documentStatus == null) {
        return this.candidate.pushed;
      } else {
        return (
          !this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].documentRejectedByRecruiter && this.candidate.pushed
        );
      }
    },
    checkShareToClient() {
      if (this.candidate.documentStatus == null) {
        return this.candidate.pushed;
      } else {
        if (
          this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].documentRejectedByRecruiter &&
          (this.candidate.documentStatus == 0 ||
            this.candidate.documentStatus == 5)
        ) {
          return false;
        } else if (
          !this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].documentRejectedByRecruiter &&
          this.candidate.documentStatus == 5 &&
          this.candidate.pushed
        ) {
          return true;
        } else {
          return this.candidate.pushed;
        }
      }
    },
  },
  methods: {
    selectCand() {
      this.$emit("select-cand", this.candidate.candidateID);
      this.addAttach = false;
    },
    closeCand() {
      this.$emit("select-cand", "");
      this.addAttach = false;
      this.addAttach = false;
    },
    closeOnOutside(event) {
      let id = "closecard" + this.candidate.candidateID;
      if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
        this.$emit("select-cand", "");
        this.addAttach = false;
        // Close the dropdown
      }
    },
  },
};
</script>

<style scoped></style>
